<script setup lang="ts">
import { EntityFaqItem, EntityFaqItemsWithSidebar } from '~/components/entity/faq'
import type { IFaqItem } from '~/components/entity/faq/items/types'

const props = defineProps<{
  variant?: 'sidebar' | 'default'
  items?: IFaqItem[]
  path?: string
  queryParams?: Record<string, unknown>
}>()

const faqs = ref<IFaqItem[]>([])

// Data fetching logic
if (props.path) {
  // If path is provided, make API request
  const query = props.queryParams
    ? new URLSearchParams(
        Object.entries(props.queryParams).map(([key, value]) => [key, String(value)])
      ).toString()
    : ''

  const apiUrl = query ? `${props.path}${query ? `?${query}` : ''}` : props.path

  const { data } = await useApi<{ data: IFaqItem[] }>(apiUrl)
  faqs.value = data.value?.data || []
} else {
  // If path is not provided, use items prop
  faqs.value = props.items || []
}
</script>

<template>
  <!-- Sidebar variant is swapped for the accordion on phones by CSS so SSR HTML is device-independent -->
  <div v-if="variant === 'sidebar'" class="hidden md:block">
    <EntityFaqItemsWithSidebar :items="faqs" />
  </div>
  <div class="Accordion" :class="{ 'md:hidden': variant === 'sidebar' }">
    <template v-for="item in faqs" :key="item.id">
      <EntityFaqItem :item="item" />
    </template>
  </div>
</template>
